var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.buttonClasses,attrs:{"to":_vm.to,"dir":"auto"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }